// const addSorting = (filter) => {
//   filter.sort.unshift({
//     field: "product_value_tags_wizzy_hero_product_ruled_based_bt:float",
//     order: "desc",
//   });
// };
const addSortingbestsellers = (filter) => {
  let isJson = false,
    isSortJson = false;

  // Parse filter if it's a string
  if (typeof filter === "string") {
    isJson = true;
    filter = JSON.parse(filter);
  }

  // Parse sort if it's a string
  if (typeof filter.sort === "string") {
    isSortJson = true;
    filter.sort = JSON.parse(filter.sort);
  }

  // Only modify if the first field is "relevance"
  if (filter.sort?.[0]?.field === "relevance") {
    const newSort = [];

    newSort.push(filter.sort[0]); // keep relevance at the top

    const bestSellerField = "product_wizzy-best-selling_sortOrder:float";
    const alreadyExists = filter.sort.some((x) => x.field === bestSellerField);
    if (!alreadyExists) {
      newSort.push({
        field: bestSellerField,
        order: "asc",
      });
    }

    for (let i = 1; i < filter.sort.length; i++) {
      if (filter.sort[i].field !== bestSellerField) {
        newSort.push(filter.sort[i]);
      }
    }

    filter.sort = newSort;
  }

  if (isSortJson) filter.sort = JSON.stringify(filter.sort);
  if (isJson) filter = JSON.stringify(filter);

  return filter;
};

const refreshTriggers = ["/pages/search", "herbspro.com/"];

function checkAndRefresh() {
  setTimeout(() => {
    const newURL = window.location.href;

    if (refreshTriggers.some((trigger) => newURL.includes(trigger))) {
      console.log("URL matches trigger, refreshing page...");
      location.reload();
    }
  }, 100);
}

// Detect Back/Forward button press
window.addEventListener("popstate", checkAndRefresh);

const addSorting = (filter) => {
  let isJson = false,
    isSortJson = false;
  typeof filter == "string" && ((isJson = true), (filter = JSON.parse(filter))),
    typeof filter.sort == "string" &&
      ((isSortJson = true), (filter.sort = JSON.parse(filter.sort)));
  let newSort = [];
  filter.sort[0].field === "relevance"
    ? (newSort.push({
        field: "product_value_tags_wizzy_hero_product_ruled_based_bt:float",
        order: "desc",
      }),
      filter.sort.forEach((x) => {
        x.field !=
          "product_value_tags_wizzy_hero_product_ruled_based_bt:float" &&
          newSort.push(x);
      }))
    : (newSort = filter.sort),
    (filter.sort = newSort),
    isSortJson && (filter.sort = JSON.stringify(filter.sort)),
    isJson && (filter = JSON.stringify(filter));
};
const addSortingforauto = (filter) => {
  let newSort = [];

  // First, push relevance
  newSort.push({
    field: "relevance",
    order: "desc", // assuming you want descending relevance; change if needed
  });

  // Then, push best-selling
  newSort.push({
    field: "product_wizzy-best-selling_sortOrder:float",
    order: "asc",
  });

  filter.sort = newSort;
};

var sourceElement = document.querySelector(".wizzy-search-sort-wrapper");

if (sourceElement) {
  var clonedContent = sourceElement.cloneNode(true);

  var targetDiv = document.querySelector(".wizzy-sort-wrapper-in-filter");

  if (targetDiv && !targetDiv.querySelector(".wizzy-search-sort-wrapper")) {
    targetDiv.appendChild(clonedContent);
  }
}

if (window.innerWidth < 768) {
  var sortInFilter = document.querySelector(
    ".wizzy-search-filters-left-wrapper .wizzy-common-select-selector"
  );
  if (
    sortInFilter &&
    !sortInFilter.classList.contains("click-listener-attached")
  ) {
    sortInFilter.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      var sortOptions = document.querySelector(".wizzy-common-select-options");
      if (sortOptions) {
        if (
          sortOptions.style.display === "none" ||
          sortOptions.style.display === ""
        ) {
          sortOptions.style.display = "grid";
        } else {
          sortOptions.style.display = "none";
        }
      }
    });
    sortInFilter.classList.add("click-listener-attached");
  }
}

if (window.innerWidth < 768) {
  document
    .querySelector(
      'input[data-js-focus-overlay="search-results-overlay-mobile"]'
    )
    .addEventListener("focus", function () {
      document.body.style.height = "100vh";
      document.body.style.overflow = "hidden";
    });

  document
    .querySelector(
      'input[data-js-focus-overlay="search-results-overlay-mobile"]'
    )
    .addEventListener("blur", function () {
      document.body.style.height = "";
      document.body.style.overflow = "";
    });
}

window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      addSortingbestsellers(data.filters);
      // addSorting(data.filters);
      return data; // Return the modified payload
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (data) {
      addSortingforauto(data);
      return data; // Return the modified payload
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      console.log("before_search", data);
      if (data?.sort?.length && data?.sort[0].field == "relevance") {
        data.sort = [
          { field: "product_same_day_shipping_custom", order: "desc" },
          {
            field: "product_value_tags_wizzy_hero_product_ruled_based_bt:float",
            order: "desc",
          },
          { field: "relevance", order: "asc" },
          { field: "product_wizzy-best-selling_sortOrder:float", order: "asc" },
        ];
      }
      document.querySelector(".search-results-overlay").click();
      if (window.innerWidth < 768) {
        document.querySelector("#search-results-overlay-mobile").click();
      }

      // document.querySelector(".wizzy-autocomplete-wrapper").style.display =
      //   "none";
      document.querySelector(".search-results-overlay").click();
      addSortingbestsellers(data);
      // addSorting(data);
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (products) {
      products.forEach((product) => {
        product.attributes.forEach((attr) => {
          if (attr.id === "product_badge_judgeme") {
            const htmlString = attr.values[0].value[0];
            const tempDiv = document.createElement("div"); // Create a temporary element
            tempDiv.innerHTML = htmlString; // Set innerHTML
            let averageRating = tempDiv
              .querySelector(".jdgm-prev-badge")
              .getAttribute("data-average-rating");
            let numberOfReviews = tempDiv.querySelector(".jdgm-prev-badge")
              .getAttribute("data-number-of-reviews");
            averageRating = parseFloat(averageRating); // Convert to a number
            product.avgRatings = averageRating === 0 ? 0 : averageRating;
            product.numberOfReviews = numberOfReviews;
          }
          if (attr.id === "product_same_day_shipping_custom") {
            if (attr.values[0].value[0] == "Yes")
              product.showsamedayshippingtag = true;
          }

           if (attr.id === "product_free_shipping_custom") {
             if (attr.values[0].value[0] == "Yes")
               product.showFreeShippingtag = true;
           }

          if (attr.id === "product_sku") {
            const skuval = attr.values[0].value[0];
            product.skuValue = skuval;
          }
          if (attr.id === "product_vendor") {
            const vendorname = attr.values[0].value[0];
            product.vendorName = vendorname;
          }

            if(attr.id === "product_cat_id_custom") {
            const cat_m_val = attr.values[0].value[0];
            product.isCat = true;
            if(cat_m_val !== 'M'){
              product.discountApplicable = true;
            }
            }

           if(product.discountApplicable && attr.id === "product_custom_label_1_custom") {
            const saveValues = [10, 15, 20, 25, 30, 35, 40];
            for (let value of saveValues) {
              if (attr.values[0].value[0].includes(`SAVE${value}`)) {
                product.hasSaveLable = true;
                product.savePercentageValue = value;
                let discount = (product.sellingPrice * product.savePercentageValue) / 100;
                let discounted = product.sellingPrice - discount;
                // Always round UP to 2 decimals
                product.discountedPriceAfterCoupen = (Math.ceil(discounted * 100) / 100).toFixed(2);
                break; // stop once matched
              }
            }

          }
           else if(product.isCat && !product.hasSaveLable && product.discountApplicable) {
              product.hasSaveLableForFive = true;
              product.savePercentageValue = 5;
              let discount = (product.sellingPrice * product.savePercentageValue) / 100;
              let discounted = product.sellingPrice - discount;
                // Always round UP to 2 decimals
                product.discountedPriceAfterCoupen = (Math.ceil(discounted * 100) / 100).toFixed(2);
            }


          if (attr.id === "product_custom_label_3_custom") {
            product.buyOneGetOne = true;
          }
        });
      });
      // // change text of filter button on mobile
      // const filterElement = document.querySelector(
      //   ".wizzy-search-wrapper .wizzy-search-results-wrapper .wizzy-filters-mobile-entry"
      // );

      // if (filterElement) {
      //   filterElement.textContent = "Filter & Sort";
      // } else {
      //   console.warn("Element not found!");
      // }

      return products;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (data) {
      console.log("BEFORE_AUTOCOMPLETE_EXECUTED", data);
      if (data?.sort?.length && data?.sort[0].field == "relevance") {
        data.sort = [
          { field: "product_same_day_shipping_custom", order: "desc" },
          {
            field: "product_value_tags_wizzy_hero_product_ruled_based_bt:float",
            order: "desc",
          },
          { field: "relevance", order: "asc" },
          { field: "product_wizzy-best-selling_sortOrder:float", order: "asc" },
        ];
      }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      console.log("BEFORE_FILTERS_EXECUTED", data);
      if (
        data?.filters?.sort?.length &&
        data?.filters?.sort[0].field == "relevance"
      ) {
        data.filters.sort = [
          { field: "product_same_day_shipping_custom", order: "desc" },
          {
            field: "product_value_tags_wizzy_hero_product_ruled_based_bt:float",
            order: "desc",
          },
          { field: "relevance", order: "asc" },
          { field: "product_wizzy-best-selling_sortOrder:float", order: "asc" },
        ];
      }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      baCurr.refreshConversion();
      if (window.innerWidth < 768) {
        window.wizzyConfig.search.configs.general.noOfProducts = 24;
        var header = document.querySelector(".wizzy-filters-header");
        var stickyElement = document.querySelector(
          ".wizzy-search-wrapper .wizzy-search-results-wrapper .wizzy-search-filters-left.wizzy-v2 .wizzy-search-filters-left-wrapper"
        );
        var closeBtn = document.querySelector(
          ".wizzy-search-wrapper .wizzy-search-results-wrapper .wizzy-search-filters-left .wizzy-filters-close-btn"
        );

        if (header && stickyElement) {
          var headerRect = header.getBoundingClientRect();
          stickyElement.style.position = "absolute";

          stickyElement.style.top = headerRect.bottom + "px";
          stickyElement.style.width = "100%";
        }

        if (closeBtn) {
          let screenHeight = window.innerHeight;
          let adjustedTop = (screenHeight / 667) * 104; // Scale proportionally
          closeBtn.style.display = "block";
          closeBtn.style.top = `${adjustedTop}px`;
        }

        var applyAll = document.querySelector(".wizzy-apply-all-button");

        document
          .querySelectorAll(".wizzy-grid-filters-box ul li")
          .forEach((li) => {
            li.addEventListener("click", () => {
              applyAll.click();
            });
          });

        const targetNode = $("body")[0];

        const observer = new MutationObserver(function () {
          if ($("body").hasClass("wizzy-overlay-opened")) {
            $(".widget-visible").each(function () {
              $(this).attr("style", "display: none !important;"); // Force !important for widget-visible
            });

            $(
              ".smile-improved-mobile-launcher, .jdgm-revs-tab-btn.btn, .omnisend-form-67c8d86307be655774af8b45-rectangle-teaser"
            ).hide(); // Regular hide (no !important)
          } else {
            $(".widget-visible").each(function () {
              $(this).removeAttr("style"); // Remove inline style
            });

            $(
              ".smile-improved-mobile-launcher, .jdgm-revs-tab-btn.btn, .omnisend-form-67c8d86307be655774af8b45-rectangle-teaser"
            ).show(); // Show normally
          }
        });

        observer.observe(document.body, {
          attributes: true,
          attributeFilter: ["class"],
        });
      }
      // addtocart change currency
      const sidebarDrawer = document.querySelector("#site-cart-sidebar");

      if (sidebarDrawer) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === "style") {
              const displayStyle =
                window.getComputedStyle(sidebarDrawer).display;
              if (displayStyle === "grid") {
                setTimeout(() => {
                  if (
                    typeof baCurr !== "undefined" &&
                    typeof baCurr.refreshConversion === "function"
                  ) {
                    baCurr.refreshConversion();
                  } else {
                    console.warn(
                      "baCurr.refreshConversion is not defined or not a function"
                    );
                  }
                }, 1000); // Delay in milliseconds (adjust as needed)
              }
            }
          });
        });

        observer.observe(sidebarDrawer, {
          attributes: true,
          attributeFilter: ["style"],
        });
      }

      // autocomplete wrapper change currency
      document.querySelectorAll(".wizzy-search-input").forEach((input) => {
        input.addEventListener("click", function () {
          setTimeout(() => {
            if (
              typeof baCurr !== "undefined" &&
              typeof baCurr.refreshConversion === "function"
            ) {
              baCurr.refreshConversion();
            } else {
              console.warn(
                "baCurr.refreshConversion is not defined or not a function"
              );
            }
          }, 100); // Delay execution by 1 second (adjust if needed)
        });
      });

      if (window.innerWidth < 768) {
        var sourceElement = document.querySelector(
          ".wizzy-search-sort-wrapper"
        );

        if (sourceElement) {
          var clonedContent = sourceElement.cloneNode(true);

          var targetDiv = document.querySelector(
            ".wizzy-sort-wrapper-in-filter"
          );

          if (
            targetDiv &&
            !targetDiv.querySelector(".wizzy-search-sort-wrapper")
          ) {
            targetDiv.appendChild(clonedContent);
          }
        }

        var sortInFilter = document.querySelector(
          ".wizzy-search-filters-left-wrapper .wizzy-common-select-selector"
        );
        if (
          sortInFilter &&
          !sortInFilter.classList.contains("click-listener-attached")
        ) {
          sortInFilter.addEventListener("click", function (event) {
            event.preventDefault();
            event.stopPropagation();
            var sortOptions = document.querySelector(
              ".wizzy-common-select-options"
            );
            if (sortOptions) {
              if (
                sortOptions.style.display === "none" ||
                sortOptions.style.display === ""
              ) {
                sortOptions.style.display = "grid";
              } else {
                sortOptions.style.display = "none";
              }
            }
          });
          sortInFilter.classList.add("click-listener-attached");
        }
      }
      if (window.innerWidth < 768) {
        document.querySelectorAll(".wizzy-facet-head").forEach((facetHead) => {
          facetHead.addEventListener("click", function () {
            let facetBlock = this.closest(".wizzy-filters-facet-block"); // Get parent
            let facetBody = facetBlock.querySelector(".wizzy-facet-body"); // Find body

            if (facetBlock.classList.contains("collapsed")) {
              facetBody.style.display = "none"; // Hide if collapsed
            } else {
              facetBody.style.removeProperty("display"); // Show (uses default CSS)
            }
          });
        });
      }

      let button = document.querySelector(".wizzy-apply-all-button");
      if (button) {
        button.textContent =
          button.textContent.charAt(0).toUpperCase() +
          button.textContent.slice(1).toLowerCase();
      }

      if (window.innerWidth < 768) {
        let a = document.querySelector(".wizzy-filters-mobile-entry");

        if (a) {
          function updateStickyPosition() {
            var header = document.querySelector(".wizzy-filters-header");
            var stickyElement = document.querySelector(
              ".wizzy-search-wrapper .wizzy-search-results-wrapper .wizzy-search-filters-left.wizzy-v2 .wizzy-search-filters-left-wrapper"
            );
            var closeBtn = document.querySelector(
              ".wizzy-search-wrapper .wizzy-search-results-wrapper .wizzy-search-filters-left .wizzy-filters-close-btn"
            );

            if (header && stickyElement) {
              var headerRect = header.getBoundingClientRect();
              stickyElement.style.position = "absolute";

              stickyElement.style.top = headerRect.bottom + "px";
              stickyElement.style.width = "100%";
            }

            if (closeBtn) {
              let screenHeight = window.innerHeight;
              let adjustedTop = (screenHeight / 667) * 104; // Scale proportionally

              closeBtn.style.top = `${adjustedTop}px`;
            }
          }

          // Click event
          a.addEventListener("click", function () {
            setTimeout(updateStickyPosition, 100);
          });

          // Resize event to adjust positioning dynamically
          window.addEventListener("resize", updateStickyPosition);
        }
      }

      // function updateVisibility() {
      //   let options = document.querySelector(
      //     ".wizzy-common-select-container .wizzy-common-select-options"
      //   );
      //   let container = document.querySelector(
      //     ".wizzy-common-select-container"
      //   );
      //   let selector = document.querySelector(".wizzy-common-select-selector");
      //   let selectedItem = document.querySelector(
      //     ".wizzy-common-select-selectedItem"
      //   );

      //   if (options && container) {
      //     let isGrid = window.getComputedStyle(options).display === "grid";

      //     if (isGrid) {
      //       options.style.top = "53px"; // Set top when display is grid
      //       container.style.overflow = "visible"; // Remove overflow:hidden
      //       if (selector) selector.classList.add("hide-after"); // Hide ::after dynamically
      //       if (selectedItem) selectedItem.style.display = "none";
      //     } else {
      //       options.style.top = ""; // Reset when not grid
      //       container.style.overflow = ""; // Restore original overflow
      //       if (selector) selector.classList.remove("hide-after");
      //       if (selectedItem) selectedItem.style.display = "";
      //     }
      //   }
      // }

      // // Observe for changes in inline styles
      // const observer = new MutationObserver(updateVisibility);
      // const targetNode = document.querySelector(".wizzy-common-select-options");

      // if (targetNode) {
      //   observer.observe(targetNode, {
      //     attributes: true,
      //     attributeFilter: ["style"],
      //   });
      // }

      // updateVisibility();

      var filterPanel = document.querySelectorAll(
        ".wizzy-search-wrapper .wizzy-search-filters-left .wizzy-filters-facet-block"
      );

      if (window.innerWidth < 768) {
        filterPanel.forEach((facet) => {
          facet.addEventListener("click", function (e) {
            const currentFilter = this; // Get the parent filter element

            const isActive = currentFilter.classList.contains("collapsed");

            // console.log(currentFilter);

            // Close all filters

            setTimeout(() => {
              filterPanel.forEach((h) => {
                const filter = h;

                if (filter !== currentFilter) {
                  filter.classList.add("collapsed");
                }
              });

              if (isActive) {
                currentFilter.classList.remove("collapsed");
              }
              // else {
              //   currentFilter.classList.add("collapsed");
              // }
            }, 100);
          });
        });
      }

      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      // window.wizzyConfig.search.configs.general.behaviour =
      //   "search_as_you_type";
      // window.wizzyConfig.autocomplete.enabled = !1;
      data.search.configs.pagination.infiniteScrollOffset = {
        desktop: 1300,
        mobile: 3000,
      };
      data.search.configs.facets.leftFacets.mobileCollapsible = true;
      data.filters.configs.keepOpenedInMobileAfterApply = true;

      return data;
    }
  );
};
